import { DEFAULT_FEEDBACK_REQUESTS_LIST_PARAMETERS } from '@entities/feedback-request/config/store-constants';
import { SearchSortParameter } from '@shared/ui/search/types';

export const SORT_FEEDBACK_REQUESTS_CLEAR_PARAMETERS: SearchSortParameter = {
    sort: DEFAULT_FEEDBACK_REQUESTS_LIST_PARAMETERS.sort,
    order: DEFAULT_FEEDBACK_REQUESTS_LIST_PARAMETERS.order,
};
